declare global {
  interface Window {
    dataLayer: unknown[];
    // eslint-disable-next-line no-unused-vars
    gtag?: (..._args: unknown[]) => void;
  }
}

export const updateGoogleConsent = (granted: boolean) => {
  if (typeof window.gtag !== "function") return;

  window.gtag("consent", "update", {
    analytics_storage: granted ? "granted" : "denied",
    ad_storage: granted ? "granted" : "denied",
    ad_user_data: granted ? "granted" : "denied",
    ad_personalization: granted ? "granted" : "denied",
  });
};